import {ServiceBase} from "../ServiceBase";
import {ILoyaltyService} from "./loyalty-indicator.service.interface"
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {ILoyaltyIndicatorViewModel} from "./models/loyalty-indicator-view-model.interface";
import {LoyaltyIndicatorModel} from "./models/loyalty-indicator.model";
import {Nullable} from "../../../common/types/nullable-types";
import {Check} from "@sparkware/app-utils";

export class LoyaltyService extends ServiceBase implements ILoyaltyService {
    constructor(services: IServiceFactoryExtended) {
        super(services);

        this.reaction(() => this.services.user.isAuthorized,
            (isAuthorized) => {
                if (!isAuthorized) {
                    if (this._loadLoyaltyPromise) {
                        this._loadLoyaltyPromise.then(model => {
                            model.dispose();
                        });
                        this._loadLoyaltyPromise = null;
                    }
                }
            }
        )
    }

    private _loadLoyaltyPromise: Nullable<Promise<ILoyaltyIndicatorViewModel>> = null;
    async init(): Promise<void> {
        if (this._loadLoyaltyPromise) {
            return;
        }

        this._loadLoyaltyPromise = this._loadLoyalty();
        
        // clear cache promis
        this._loadLoyaltyPromise.catch((err) => {
            this._loadLoyaltyPromise = null;
            throw err;
        });

    }

    private async _loadLoyalty() {
        await this._loadLoyaltyScript();
        const fireBaseToken = await this._getFirebaseToken();
        const platformToken = await this.services.user.getPlatformToken();

        return new LoyaltyIndicatorModel(this.services, {
            platformToken: platformToken.token,
            firebaseToken: fireBaseToken,
        });
    }

    private _loadLoyaltyScriptPromise: Nullable<Promise<void>> = null;
    private _loadLoyaltyScript(): Promise<void> {
        if (!this._loadLoyaltyScriptPromise) {
            if(Check.isEmpty(this.services.configuration.servicesConfigs.Loyalty.scriptLink)){
                return Promise.resolve();
            }
            this._loadLoyaltyScriptPromise = this.services.scriptLoader.loadScript({
                url: this.services.configuration.servicesConfigs.Loyalty.scriptLink
            });
        }

        return this._loadLoyaltyScriptPromise;
    }

    private async _getFirebaseToken(): Promise<string> {
        const fireBaseToken = this.services.sdk.getFirebaseToken();
        if (fireBaseToken) {
            return Promise.resolve(fireBaseToken);
        }

        return new Promise<string>((resolve, reject) => {
            const timeout = setTimeout(() => {
                subscription.off();
                reject('onFirebaseGotNewToken timeout');
            }, 10000);

            const subscription = this.services.sdk.events.onFirebaseGotNewToken(({token}) => {
                subscription.off();
                clearTimeout(timeout);
                resolve(token);
            })
        })
    }
}